export function Dashboard() {
  return <div>This is admin Dashboard</div>;
}
